/** UUID файлов, удалённых на узле */
export class RemovedFiles {
  removed: string[]

  constructor({ removed }: { removed: string[] }) {
    this.removed = removed
  }
}
